import { render, staticRenderFns } from "./Statistical.vue?vue&type=template&id=4b92cf50&scoped=true"
import script from "./Statistical.vue?vue&type=script&lang=js"
export * from "./Statistical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b92cf50",
  null
  
)

export default component.exports